import React, { Component, useState, useEffect } from "react";
import { withStyles, withTheme } from "@material-ui/core/styles";
import { connect } from "react-redux";
import { Card } from "@material-ui/core";
import { withRouter } from "react-router";
import { useTranslation } from "react-i18next";
import { makeStyles } from "@material-ui/core/styles";
import SwipeableViews from "react-swipeable-views";
import ReusableSections from "./ReusableSections";
import ReusableSection from "./ReusableSection";

const useStyles = makeStyles((theme) => ({}));
function ReusableSectionsSelectable(props) {
  const [selectedSection, setSelectedSection] = useState({});
  const [selected, setSelected] = useState(0);
  const classes = useStyles();
  const { t } = useTranslation();
  const onSelected = (content) => {
    setSelectedSection(content);
    setSelected(1);
    props.reusableSectionSelected(content);
  };
  const onBack = () => {
    setSelected(0);
    setSelectedSection({});
    // props.reusableSectionSelected("");
  };
  return (
    <SwipeableViews
      index={selected}
      style={{ height: "100%" }}
      slideClassName="swipeable-slide"
      slideStyle={{ overflowX: "hidden", width: "100%" }}
    >
      {selected === 0 && (
        <ReusableSections addSection onSelected={onSelected} />
      )}
      {selected === 1 && (
        <div
          style={{
            width: "100%",
            height: "100%",
            display: "flex",
            flexDirection: "row",
            backgroundColor: "#eae0d7",
            backgroundImage: "url('../images/background.svg')",
          }}
        >
          <div style={{ width: "25%", height: "100%" }} />
          <div
            style={{
              height: "100%",
              width: !props.addSection ? "100%" : "50%",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                height: "100%",
                overflow: "auto",
              }}
            >
              <Card raised id="card" style={{ margin: "16px" }}>
                <ReusableSection
                  selected
                  onBack={onBack}
                  addSection={props.addSection}
                  section={selectedSection}
                />
              </Card>
            </div>
          </div>
          <div style={{ width: "25%", height: "100%" }} />
        </div>
      )}
    </SwipeableViews>
  );
}
const mapStateToProps = (state) => ({
  user: state.user.currentUser,
});
export default connect(
  mapStateToProps,
  null
)(withRouter(withTheme(ReusableSectionsSelectable)));
